import React from "react";
import '../styles/terms.css';

function Terms() {
  return (
    <body className="terms-body">
      <div className="terms">
      <h1><span>Terms</span> and Conditions</h1>

      <h4>1. Acceptance of Terms</h4>
      <p>
        By accessing or using this web application, you agree to comply with and
        be bound by these Terms and Conditions. If you do not agree with any
        part of these terms, you may not use the application.
      </p>

      <h4>2. User Registration</h4>
      <p>
        To access certain features of the application, you may be required to
        register for an account. You are responsible for maintaining the
        confidentiality of your account information and password.
      </p>

      <h4>3. User Conduct</h4>
      <p>
        You agree to use the application only for lawful purposes and in a way
        that does not infringe on the rights of any other user or third party.
      </p>

      <h4>4. Privacy Policy</h4>
      <p>
        Your use of the application is also governed by our Privacy Policy,
        which outlines how we collect, use, and protect your personal
        information.
      </p>

      <h4>5. Intellectual Property</h4>
      <p>
        The content and materials available on this application are protected by
        intellectual property laws. You may not use, modify, reproduce, or
        distribute any content without the owner's written consent.
      </p>

      <h4>6. Limitation of Liability</h4>
      <p>
        We are not liable for any direct, indirect, incidental, consequential,
        or special damages arising out of or in any way connected with your use
        of this application.
      </p>

      <h4>7. Termination</h4>
      <p>
        We reserve the right to terminate or suspend your account and access to
        the application at our sole discretion without notice for any reason,
        including violation of these Terms.
      </p>

      <h4>8. Changes to Terms</h4>
      <p>
        We may update these Terms and Conditions from time to time. Your
        continued use of the application after any changes constitutes
        acceptance of those changes.
      </p>

      <h4>9. Governing Law</h4>
      <p>
        These Terms and Conditions are governed by and construed in accordance
        with the laws of [Your Jurisdiction].
      </p>

      <h6 id="upd">Last Updated: [12 December, 2023]</h6>
    </div>
    </body>
  );
}

export default Terms;
